import React, { useEffect, useState } from 'react'
import { Box, Grid } from '@mui/material'
import World from '../../Components/World/World.js'
import Advertise from '../../Components/Advertise/Advertise.js'
import { Link } from 'react-router-dom'
import NewsSection from '../News/NewsSection.js'
import { bannerAdds, getAllBox, getFilteredNewsData, getGroupedCategory, latestHomeThreeNews } from '../../../Services/UserServices.js'
import Loader from '../../../Components/Loader/Loader.js'
import { scrollToLastVisitedItem } from '../../../Helper/helper.js'

function UserDasbboard() {

    const [latestNews, setLaststNews] = useState([]);
    const [bannerAds, setBannerAds] = useState([]);
    const [groupedCategory, setGroupedCategory] = useState([]);
    const [ads, setAds] = useState([]);
    const [latestNewsSession, setLatestNewsSession] = useState([]);

    // Loader
    const [loading, setLoading] = useState(false);

    const getData = async () => {
        window.scrollTo(0, 0);
        setLoading(true);
        try {

            await latestHomeThreeNews().then((res) => {
                let data = res?.data?.news;
                setLaststNews(data);
            })
            await bannerAdds().then((res) => {
                let data = res?.data?.ads;
                if (data) {
                    setBannerAds(data);
                }
            })
            await getGroupedCategory().then((res) => {
                let data = res?.data?.newsByCategory;
                setGroupedCategory(data);
            })
            await getAllBox().then((res) => {
                let data = res?.data?.ads;
                setAds(data);
            })

            let filter = {
                "categoryName": "",
                "type": "Main",
                "count": 5
            }
            await getFilteredNewsData(filter).then((res) => {
                let data = res?.data?.latestNews;
                setLatestNewsSession(data);
            })
        } catch (err) {
            setLoading(false);
            console.log(err)
        } finally {
            setLoading(false);
            scrollToLastVisitedItem();
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        getData();
    }, []);


    if (loading) {
        return <Loader />
    }

    return (
        <div>
            <div style={{ paddingTop: 20 }}>
                <World latestNews={latestNews} />
            </div>
            <div style={{ paddingTop: 20 }}>
                <Advertise bannerAds={bannerAds} />
            </div>
            <div style={{ paddingTop: 20 }}>
                <NewsSection groupedCategory={groupedCategory} ads={ads} filteredNews={latestNewsSession} />
            </div>
            <div style={{ paddingTop: 20 }}>
                <Grid container spacing={2}>
                    {(bannerAds.length > 0 ? bannerAds.slice(0, 2) : [null]).map((each, index) => (
                        <Grid item xs={12} sm={bannerAds.length > 1 ? 6 : 12} key={index}>
                            <Link to={each?.link || "#"}>
                                <Box
                                    sx={{
                                        width: '100%',
                                        aspectRatio: '3.3 / 1',
                                        borderRadius: 'var(--gn-radius)',
                                        boxShadow: 'var(--gn-card-shadow)',
                                        background: '#f4f5fa',
                                        overflow: 'hidden',
                                        display: 'flex',
                                    }}
                                >
                                    <Box
                                        component="img"
                                        src={each?.image?.url || "/UserSideImages/default_Add.jpeg"}
                                        alt={`Ad ${index + 1}`}
                                        sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                    />
                                </Box>
                            </Link>
                        </Grid>
                    ))}
                </Grid>
            </div>
        </div>
    )
}

export default UserDasbboard;